import { serviceModel } from '~/models';
import { InlineStartBillingMenuItem } from './InlineStartBillingControl';
export function applyNewSelection(param) {
    let { serviceId, newItem, previousItem, handlers, getInitialEffectiveDate } = param;
    switch(newItem){
        case InlineStartBillingMenuItem.NextBillingDay:
            if (previousItem === InlineStartBillingMenuItem.ManualInitiation) {
                var _handlers_onPausedChange;
                return (_handlers_onPausedChange = handlers.onPausedChange) === null || _handlers_onPausedChange === void 0 ? void 0 : _handlers_onPausedChange.call(handlers, serviceId, false);
            } else if (previousItem === InlineStartBillingMenuItem.AcceptanceDate) {
                var _handlers_onBillOnAcceptanceChange;
                return (_handlers_onBillOnAcceptanceChange = handlers.onBillOnAcceptanceChange) === null || _handlers_onBillOnAcceptanceChange === void 0 ? void 0 : _handlers_onBillOnAcceptanceChange.call(handlers, serviceId, false);
            } else if (previousItem === InlineStartBillingMenuItem.SpecificDate) {
                var _handlers_onStartBillingAtChange;
                return (_handlers_onStartBillingAtChange = handlers.onStartBillingAtChange) === null || _handlers_onStartBillingAtChange === void 0 ? void 0 : _handlers_onStartBillingAtChange.call(handlers, serviceId, null);
            }
            break;
        case InlineStartBillingMenuItem.SpecificDate:
            var _handlers_onStartBillingAtChange1;
            (_handlers_onStartBillingAtChange1 = handlers.onStartBillingAtChange) === null || _handlers_onStartBillingAtChange1 === void 0 ? void 0 : _handlers_onStartBillingAtChange1.call(handlers, serviceId, getInitialEffectiveDate());
            break;
        case InlineStartBillingMenuItem.AcceptanceDate:
        case InlineStartBillingMenuItem.Today:
            var _handlers_onBillOnAcceptanceChange1;
            (_handlers_onBillOnAcceptanceChange1 = handlers.onBillOnAcceptanceChange) === null || _handlers_onBillOnAcceptanceChange1 === void 0 ? void 0 : _handlers_onBillOnAcceptanceChange1.call(handlers, serviceId, true);
            break;
        case InlineStartBillingMenuItem.ManualInitiation:
            var _handlers_onPausedChange1;
            (_handlers_onPausedChange1 = handlers.onPausedChange) === null || _handlers_onPausedChange1 === void 0 ? void 0 : _handlers_onPausedChange1.call(handlers, serviceId, true);
            break;
    }
}
export function getStartBillingSelection(service) {
    if (serviceModel.isPaused(service)) {
        return InlineStartBillingMenuItem.ManualInitiation;
    }
    if (serviceModel.startBillingAt(service)) {
        return InlineStartBillingMenuItem.SpecificDate;
    }
    if (serviceModel.isBillOnPeriodBeforeNextBilling(service)) {
        if (serviceModel.isFromAmendment(service)) {
            return InlineStartBillingMenuItem.Today;
        }
        return InlineStartBillingMenuItem.AcceptanceDate;
    }
    return InlineStartBillingMenuItem.NextBillingDay;
}
